var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllNoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-311 -124)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(295 -80)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 204)",
    fill: "none",
    stroke: "#e8716d",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 17,
    height: 17,
    rx: 1.5,
    fill: "none"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllNoIcon);
export default __webpack_public_path__ + "static/media/all-no-icon.ff51bcd8.svg";
export { ForwardRef as ReactComponent };